export const messagesRoot =
  process.env.REACT_APP_AZURE_API_SECURED_MESSAGE_CENTER + "messages/";

export const helloSignApiRoot = process.env.REACT_APP_FORMS_MANAGER;
